<template>
  <div 
    class="xit-fb-template button node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-mouse-pointer card-button-icon"></i> {{node.lingualName}} 
        <span v-if="node.data.buttonType" class="text-center text-dark button_type_text">
          {{ node.data.text }}
        </span>
      </p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      
      <div ref="displayStatHtml"></div>

      <div class="">
        <div class="text-center mb-1">        
          <input type="text" class="single_button btn btn-light mt-0" placeholder="Button" :value="node.data.buttonText">
        </div>

        <div class="list-group">

          <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="'post_back' === node.data.buttonType">
            <div class="d-flex w-100 justify-content-between">
              <h6 class="mb-1 card-data-title">
                {{ node.data.postback_text }}
              </h6>              
            </div>           
          </span>

         
          <h6 class="mb-1 card-data-title text-center" v-else-if="(node.data.buttonType==='web_url' || node.data.buttonType==='web_url_full' || node.data.buttonType==='web_url_compact' || node.data.buttonType==='web_url_tall') && node.data.value">
            <a :href="node.data.value" :title="node.data.value" class="link-preview" target="_BLANK">{{ node.data.value }}</a>
          </h6>  

          <span class="list-group-item list-group-item-action flex-column align-items-start" v-else-if="node.data.buttonType==='phone_number'">
            <div class="d-flex w-100 justify-content-between">
              <h6 class="mb-1 card-data-title">
                <i class="fas fa-phone-square text-primary"></i> {{ node.data.value }}
              </h6>              
            </div>           
          </span> 
        </div>
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { templateComponentMethods, updateNodeConnections } from '../../utils/functions'

export default {
  name: 'ButtonTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  methods: {
    ...templateComponentMethods,
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>
